// extracted by mini-css-extract-plugin
module.exports = {"Quote":"styles_Quote__Htskx","cite":"styles_cite__FUXyd","quote":"styles_quote__uHzaT"};